export default __webpack_public_path__ + "d0cf07320cae8203fd276f23fbf97d49.pdf";